import React from 'react';
import { Link } from 'react-router-dom';
import '../Menu.css';

const Menu = () => {
  return (
    <div className="menu-container">
      <ul className="menu-list">
      <h1>Menu</h1>
        <li>
          <Link to="/Race Dashboard" className="menu-link">
              Race Dashboard
          </Link>
        </li><br />
        <li>
          <Link to="/TeamFlow" className="menu-link">
            TeamFlow
          </Link>
        </li>
        <br />
        <li>
          <Link to="/ComercielsFoldersAndDV" className="menu-link">
            Comerciels dV / Dossiers
          </Link>
        </li><br />
        <li>
          <Link to="/RelancesFoldersAndDV" className="menu-link">
            Relance dV / Dossiers
          </Link>
        </li><br />
        <li>
          <Link to="/SourcingFoldersAndDV" className="menu-link">
            Sourcing dV / Dossiers
          </Link>
        </li><br />
        <li>
          <Link to="/both-folders-and-dv" className="menu-link">
            Relance And Sourcing dV / Dossiers
          </Link>
        </li><br />
        <li>
          <Link to="/commandes-folders" className="menu-link">
            Commande
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Menu;